{
  "slug": "stanford-binet-intelligence-scales",
  "title": "Stanford–Binet Intelligence Scales Explained",
  "description": "An individually administered assessment spanning cognitive factors and age ranges.",
  "category": "Science of testing",
  "sections": [
    {
      "heading": "Definition and role",
      "paragraphs": [
        "An individually administered assessment spanning cognitive factors and age ranges.",
        "The construct is inferred from performance across selected tasks; it is not directly observed."
      ]
    },
    {
      "heading": "Assessment",
      "paragraphs": [
        "Professional interpretation considers standardized administration, age norms, reliability, validity, and confidence intervals.",
        "Language, motor and sensory access, education, culture, fatigue, and health matter."
      ]
    },
    {
      "heading": "Limits",
      "paragraphs": [
        "No task captures the full construct. Combine results with history and real-world functioning.",
        "Online examples illustrate formats but do not reproduce secure professional materials."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [],
  "faqs": [],
  "summary": "An individually administered assessment spanning cognitive factors and age ranges. Content reviewed 18 July 2026."
}
